<template>
    <span v-b-popover.hover.top="notifyDateLabel">
        <base-button :disabled="shouldDisable" size="sm" :aria-label="notifyDateLabel" @click="notifyFinance()"
            class="btn-dark"> <i class="tim-icons icon-email-85"></i> NOTIFY FINANCE</base-button>
    </span>
</template>

<script>
import { BaseButton } from "@/components";
import Util from "@/util/util";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
    components: {
        BaseButton
    },
    name: "notify-finance",
    props: {
        signatureUrl: {
            type: String,
            default: "",
        },
        reload: {
            type: Function
        },
        notifyDate: {
            type: String,
            default: "",
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
          dateLabel: 'Notify Finance',
          //shouldDisable: true
        }
    } ,
    computed: {
        notifyDateLabel() {
            return Util.isNullOrEmpty(this.notifyDate) ? `Notify Finance` :
                `${moment(this.notifyDate).format("DD-MMMM-YYYY h:mm a")}`
        },
        shouldDisable() {
            return this.isDisabled;
        }
    },
    watch: {
        notifyDate(newValue) {
            this.dateLabel = this.notifyDateLabel
        }
    },
   
    methods: {
        async notifyFinance() {
            //send the notification
            this.axios.get(this.signatureUrl).then((response) => {
                //Load the data
                // this.notifyDate = response.data;
                //this.isDisabled = true;
                this.$emit('update-status');
                this.$toast.success( "Success: Your requst was successfully sent!");
            }).catch((err) => {
                if (err.response.data.Error) {
                this.$toast.error(err.response.data.Error);
                } else {
                    if(err.response.data.message) {
                        this.$toast.error(err.response.data.message);
                    } else {
                        this.$toast.error(err.response.data);
                    }
                }
            })
        }
    }
};
</script>
<style></style>